module.exports = __webpack_public_path__ + "static/img/turn_1.eccb08e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/turn_1.png
// module id = 9NHS
// module chunks = 1